import OldInvestmentTaxRegime from "./oldInvestmentTaxRegime.";
export default OldInvestmentTaxRegime;